// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c683f289","455":"d309f53a","762":"73d9b8ef","857":"6f83c471","977":"2fe294a2"}[chunkId] + ".chunk.js";
};